import { root, AllServicesTypes, IComponentViewController } from '@estee/elc-universal-utils';

export function getServices() {
    return root.ServiceRegistry || {};
}

export function hasServiceStarted(service: AllServicesTypes) {
    return service.isStarted;
}
// isLazy is true for exported services by createServiceManifest
export function isServiceLazy(service: AllServicesTypes) {
    return Boolean(service.isLazy);
}
// createServiceManifest exports an object with fewer keys
export function isServiceFromManifest(service: AllServicesTypes) {
    // @ts-ignore
    return Boolean(service.getView) && isServiceLazy(service);
}
// To be removed after SDFEFND-1853
export function isServiceUpdated(service: AllServicesTypes) {
    return Boolean(service.views); // key added in elc-service v7.x
}

/* SSR */
export interface IComponentDataState {
    [key: string]: object | number | string;
}
export interface IComponentState extends IComponentDataState {
    children: string[];
}

export function setStateInController(state: object, controller: IComponentViewController) {
    const viewState = Object.values(state)[0]; // { [VIEW_NAME]: { ...state } }
    if (viewState && controller.setSSRState) {
        controller.setSSRState(viewState);
    }
}

export function setControllerId(config: string | null, controller: IComponentViewController) {
    if (config && controller.setId) {
        controller.setId(config);
    }
}

export function parseState(state: string | null) {
    let parsedState: IComponentState | undefined;
    try {
        if (state) {
            parsedState = JSON.parse(state);
        }
    } finally {
        parsedState = parsedState ? parsedState : { children: [] };
    }

    return parsedState;
}

export function initializeControllerForSSR(
    viewController: IComponentViewController | null,
    state: IComponentDataState,
    config: string | null
) {
    if (viewController) {
        setStateInController(state, viewController);
        setControllerId(config, viewController);
    }
}
